import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./App.css";
import useNotifications from "./utils/useNotifications"; // adjust path

import AppRouter from "./router/AppRouter";
import NavBar from "./Navigation/Navbar"; // adjust path if needed

ModuleRegistry.registerModules([AllCommunityModule]);

const App: React.FC = () => {
  const storedUsername = localStorage.getItem("username") || null;

  const navigate = useNavigate();
  const location = useLocation();
  const notifications = useNotifications(storedUsername || "System");
  useEffect(() => {
console.log('notifications>>>>>>>' , notifications)
    if (notifications.length > 0) {
      // show the latest notification
      const latest = notifications[notifications.length - 1];
      console.log("New notification:", latest.message);
    }
  }, [notifications]);
  useEffect(() => {
    const checkTokenExpiry = () => {
      const token = localStorage.getItem("token");
      if (!token) return;

      const payload = JSON.parse(atob(token.split(".")[1]));
      const now = Date.now() / 1000;

      if (payload.exp < now) {
        localStorage.removeItem("token");
        alert("Session expired. Please log in again.");
        navigate("/"); // Navigate to login
      }
    };

    checkTokenExpiry();
    const interval = setInterval(checkTokenExpiry, 2000);
    return () => clearInterval(interval);
  }, [navigate]);

  // Check if current route is login page
  const isLoginPage = location.pathname === "/";

  return (
    <div className="App" style={{ height: "100%" }}>
      {!isLoginPage && <NavBar />}
      <AppRouter />
    </div>
  );
};

export default App;
